import { fromHttpPromise } from 'pulse/adapters';
import { batchScheduler } from 'batch-promise';
import { extractCrmObject, consumeEarlyCrmObject, makeCrmObjectBatchUrl } from './early';
const scheduler = batchScheduler().read().identity(({
  objectTypeId,
  objectId
}) => `${objectTypeId}:${objectId}`).partition(({
  objectTypeId
}) => objectTypeId).execute(async (calls, objectTypeId) => {
  const callsArray = Object.values(calls);
  return callsArray[0].httpClient.get(await makeCrmObjectBatchUrl(objectTypeId, callsArray));
}).extract(extractCrmObject).chunkSize(25).immediate();
const fetchCrmObject = (httpClient, coords) => consumeEarlyCrmObject(coords).catch(() => scheduler.queue(Object.assign({
  httpClient
}, coords)));
export const defaultCrmObjectResolver = fromHttpPromise('crmObjectResolver', fetchCrmObject);
export const __TEST_ONLY_abortCrmObjectLiteScheduler = () => scheduler.abort();